import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";

import { DaoService } from "src/app/services/dao.service";
import { ChecklistDatabase } from "src/app/admin/api-group/api-group.component";
import { Router } from "@angular/router";
import { ApiGroupComponent } from "src/app/admin/api-group/api-group.component";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { ToastService } from "src/app/services/toast.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatDialogRef } from "@angular/material/dialog";
import { decryptData, encryptData } from "src/app/services/aes.service";
//for tree delete

@Component({
  selector: "app-userdelete",
  templateUrl: "./userdelete.component.html",
  styleUrls: ["./userdelete.component.scss"],
})
export class UserdeleteComponent implements OnInit {
  dataSource: any;
  userid: any;
  groupId: any;
  userList: any;
  groupList: any;
  attributeId: any;
  attributeList: any;
  responseMappingId: any;
  responseMappingList: any;
  deleteNode: any;
  apiSourceName: any;
  categoryId: any;
  categoryList: any;
  subcategoryId: any;
  subcategoryList: any;

  public deleteType = {
    isUser: false,
    isGroup: false,
    isAttribute: false,
    isResponseMapping: false,
    isApi: false,
    isCategory: false,
    isSubCategory: false,
  };

  private paginator: MatPaginator;
  constructor(
    private daoService: DaoService,
    public dialogRef: MatDialogRef<UserdeleteComponent>,
    private _database: ChecklistDatabase,
    private router: Router,
    private api: ApiGroupComponent,
    private spinner: SpinnerService,
    private toast: ToastService
  ) {
    //User Delete
    this.daoService.fuserId.subscribe((data: any) => {
      this.userid = data;
    });

    //ApigroupDelete
    this.daoService.finalapiId.subscribe((data: any) => {
      this.groupId = data;
    });

    //Attribute Delete
    this.daoService.finalattributeId.subscribe((data: any) => {
      this.attributeId = data;
    });

    this.daoService.finalcategoryId.subscribe((data: any) => {
      this.categoryId = data;
    });

    this.daoService.finalsubcategoryId.subscribe((data: any) => {
      this.subcategoryId = data;
    });

    //ResponseMapping Delete
    this.daoService.finalresponseMappingId.subscribe((data: any) => {
      this.responseMappingId = data;
    });

    //Find delete type
    this.daoService.isgroupdelete.subscribe((data: any) => {
      this.deleteType.isGroup = data;
    });

    this.daoService.isuserdelete.subscribe((data: any) => {
      this.deleteType.isUser = data;
    });

    this.daoService.isAttributedelete.subscribe((data: any) => {
      this.deleteType.isAttribute = data;
    });

    this.daoService.isCategorydelete.subscribe((data: any) => {
      this.deleteType.isCategory = data;
    });
    this.daoService.isSucategorydelete.subscribe((data: any) => {
      this.deleteType.isSubCategory = data;
    });

    this.daoService.isResponsMappingdelete.subscribe((data: any) => {
      this.deleteType.isResponseMapping = data;
    });

    this.daoService.isApiDelete.subscribe((data: any) => {
      this.deleteType.isApi = data;
    });

    this.daoService.finalApiNode.subscribe(
      (apiSourceName) => (this.apiSourceName = apiSourceName)
    );
  }

  ngOnInit() {}

  deleteuser() {
    this.spinner.show();
    this.daoService.deleteUserById(this.userid).subscribe(
      (data: any) => {
        this.daoService.finalUserList.subscribe(
          (userList) => (this.userList = userList)
        );
        this.userList = this.removeFromArrayOfHash(
          this.userList,
          "userId",
          data.data.userId
        );
        this.daoService.defaultUserList(this.userList);
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("User deleted successfully", "close");
      },
      (error) => {
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Something went wrong", "close");
      }
    );
  }

  deletegroup() {
    this.spinner.show();
    this.daoService.deleteGroupById(this.groupId).subscribe(
      (data: any) => {
        this.daoService.finalApiGroupList.subscribe(
          (groupList) => (this.groupList = groupList)
        );
        this.groupList = this.removeFromArrayOfHash(
          this.groupList,
          "groupId",
          data.data.groupId
        );
        this.daoService.defaultGroupList(this.groupList);
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Group deleted successfully", "close");
      },
      (error) => {
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Something went wrong", "close");
      }
    );
  }

  deleteAttribute() {
    this.spinner.show();
    this.daoService.deleteAttributeById(this.attributeId).subscribe(
      (data: any) => {
        this.daoService.finalattributeList.subscribe(
          (attributeList) => (this.attributeList = attributeList)
        );
        this.attributeList = this.removeFromArrayOfHash(
          this.attributeList,
          "attributeId",
          data.data.attributeId
        );
        this.daoService.defaultAttributeList(this.attributeList);
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Attribute deleted successfully", "close");
      },
      (error) => {
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Something went wrong", "close");
      }
    );
  }

  deleteCategory() {
    this.spinner.show();
    this.daoService.deleteCategoryById(this.categoryId).subscribe(
      (data: any) => {
        console.log("Category response");
        console.log(data);

        this.daoService.finalCategoryList.subscribe(
          (categoryList) => (this.categoryList = categoryList)
        );
        this.categoryList = this.removeFromArrayOfHash(
          this.categoryList,
          "categoryId",
          data.data.categoryId
        );
        this.daoService.defaultCategoryList(this.categoryList);
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Category deleted successfully", "close");
      },
      (error) => {
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Something went wrong", "close");
      }
    );
  }

  deleteSubCategory() {
    this.spinner.show();
    this.daoService.deleteSubcategoryById(this.subcategoryId).subscribe(
      (data: any) => {
        this.daoService.getSubcategoryList().subscribe((subdata: any) => {
          console.log("subdata");
          console.log(subdata);
          this.daoService.defaultSubCategoryList(subdata);
          this.spinner.hide();
          this.dialogRef.close();
          this.toast.openSnackBar("SubCategory deleted successfully", "close");
        });
      },
      (error) => {
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Something went wrong", "close");
      }
    );
  }

  deleteResponse() {
    this.spinner.show();
    this.daoService.deleteResponseMappingById(this.responseMappingId).subscribe(
      (data: any) => {
        this.daoService.finalresponsemappingList.subscribe(
          (responseMappingList) =>
            (this.responseMappingList = responseMappingList)
        );
        this.responseMappingList = this.removeFromArrayOfHash(
          this.responseMappingList,
          "apiMappingId",
          data.apiMappingId
        );
        this.daoService.defaultResponseMappingList(this.responseMappingList);
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar(
          "Response mapping deleted successfully",
          "close"
        );
      },
      (error) => {
        this.spinner.hide();
        this.dialogRef.close();
        this.toast.openSnackBar("Something went wrong", "close");
      }
    );
  }

  deleteApidata() {
    this.spinner.show();
    this.daoService.finalApiNode.subscribe(
      (apiId) => (this.deleteNode = apiId)
    );

    var data1 = {
      GroupId: this.deleteNode.apiId,
    };
    this.daoService
      .deleteApimanagerById(encryptData(JSON.stringify(data1)))
      .subscribe(
        (data: any) => {
          let grp = JSON.parse(decryptData(data.key));
          this.api.deleteItem();
          this.spinner.hide();
          this.dialogRef.close();
          this.toast.openSnackBar("Api deleted successfully", "close");
        },
        (error) => {
          this.spinner.hide();
          this.dialogRef.close();
          this.toast.openSnackBar("Something went wrong", "close");
        }
      );
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter(
      (l_cur_row) => l_cur_row[p_key] != p_value_to_remove
    );
  }

  closedialog() {
    this.dialogRef.close();
  }
}
